import { render, staticRenderFns } from "./workShop.vue?vue&type=template&id=07dba2e6&scoped=true"
import script from "./workShop.vue?vue&type=script&lang=js"
export * from "./workShop.vue?vue&type=script&lang=js"
import style0 from "./workShop.vue?vue&type=style&index=0&id=07dba2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dba2e6",
  null
  
)

export default component.exports